import { type ReactNode, useState, useRef, useEffect } from 'react'

interface ChartTooltipProps {
  content: ReactNode
  visible: boolean
  x: number
  y: number
  containerRef: React.RefObject<HTMLElement | null>
}

export function ChartTooltip({ content, visible, x, y, containerRef }: ChartTooltipProps) {
  const tooltipRef = useRef<HTMLDivElement>(null)
  const [position, setPosition] = useState({ left: x, top: y })

  useEffect(() => {
    if (!visible || !tooltipRef.current || !containerRef.current) return

    const container = containerRef.current.getBoundingClientRect()
    const tooltip = tooltipRef.current.getBoundingClientRect()

    let left = x + 12
    let top = y - tooltip.height / 2

    // Keep within container bounds
    if (left + tooltip.width > container.width) {
      left = x - tooltip.width - 12
    }
    if (top < 0) top = 4
    if (top + tooltip.height > container.height) {
      top = container.height - tooltip.height - 4
    }

    setPosition({ left, top })
  }, [visible, x, y, containerRef])

  if (!visible) return null

  return (
    <div
      ref={tooltipRef}
      className="pointer-events-none absolute z-50 rounded-md border border-[var(--border)] bg-[var(--surface)] px-3 py-2 text-sm font-[var(--font-family-body)] text-[var(--foreground)] shadow-md"
      style={{ left: position.left, top: position.top }}
    >
      {content}
    </div>
  )
}
